import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { useFormInput } from '@/components/hooks/useFormInput'
import { FormOnBoardingButtons } from './OnboardingButtons'
import { AvatarSelectOptionsInput } from './FieldCircleCheckboxV2'
import { PROFILE_ICONS } from './AccountKidProfile'

const NEXT_STEP = ON_BOARDING_STATES.SPORTS

export function OnBoardingAvatar() {
  const context = useMobileFiltersContext()
  const currentChild = context.getCurrentChild()
  const [_, avatar] = currentChild?.steps ?? {}
  const { formInputs, handleOnChange } = useFormInput({
    avatar: avatar.value ?? ''
  })
  return (
    <form
      className={'flex flex-col gap-4'}
      onSubmit={(e) => {
        e.preventDefault()
        const id = formInputs.avatar.value
        const input = {
          value: id,
          url: PROFILE_ICONS[id]
        }

        /** Have the fetch here to  */

        context.handleUpdateConfig(input)
        context.handleNextStep(NEXT_STEP)
      }}
    >
      <div className={'flex flex-row gap-4'}>
        <AvatarSelectOptionsInput
          name={formInputs.avatar.key}
          value={formInputs.avatar.value}
          required={true}
          label={'Avatar'}
          onChange={handleOnChange}
          options={PROFILE_ICONS.map((icon, i) => ({
            avatarUrl: icon.icon,
            value: i,
            backgroundColour: icon.background_colour
          }))}
        />
      </div>

      <FormOnBoardingButtons disabled={!formInputs.avatar.value} />
    </form>
  )
}
